

import clientAPI from "@/api/ClientAPIMixin.js";
//import Vue from "vue"



export const JobCustomer = {
  namespaced: true,

  state: {
    //lists
    CustomerAdresses: null,
    CustomerContacts: null,

    //objects
    Customer: null,
    CustomerLoading: false,
    CustomerDeliveryAdress: null,
    CustomerContact: null,
    
    //loading states
    SwappingAddress: false,
    SwappingContact: false,
  },

  mutations: {
    //lists
    SET_CUSTOMER_ADRESSES(state, newcustomeradresses) {
      state.CustomerAdresses = newcustomeradresses;
    },
    SET_CUSTOMER_CONTACTS(state, newcustomercontacts) {
      state.CustomerContacts = newcustomercontacts;
    },

    //objects
    SET_CUSTOMER(state, newcustomer) {
      state.Customer = newcustomer;
    },
    SET_CUSTOMER_DELIVERY_ADRESS(state, newcustomerdeliveryadress) {
      state.CustomerDeliveryAdress = newcustomerdeliveryadress;
    },
    SET_CUSTOMER_CONTACT(state, newcustomercontact) {
      state.CustomerContact = newcustomercontact;
    },
    
    //loading states
    SET_SWAPPING_ADDRESS(state, value) {
      state.SwappingAddress = value;
    },
    SET_SWAPPING_CONTACT(state, value) {
      state.SwappingContact = value;
    },
  },

  actions: {

    /**============================================
     *?ANCHOR               CONTACT LIST
     *=============================================**/
    setCustomerContacts({ commit }, newcustomercontacts) {
      commit("SET_CUSTOMER_CONTACTS", newcustomercontacts);
      if (newcustomercontacts.length > 0) {
        commit("SET_CUSTOMER_CONTACT", newcustomercontacts[0]);
      }
      else {
        commit("SET_CUSTOMER_CONTACT", null);
      }
    },

    getCustomerContacts({ dispatch }, id) {
      clientAPI.methods.getCustomerContactsByCustomerId(id)
        .then((response) => {
          dispatch('setCustomerContacts', response);
        })

    },

    /**============================================
     *?ANCHOR               ADDRESS LIST
     *=============================================**/
    setCustomerAdresses({ commit }, newcustomeradresses) {
      commit("SET_CUSTOMER_ADRESSES", newcustomeradresses);
    },

    getCustomerAdresses({ dispatch }, id) {
      clientAPI.methods.getCustomerAdressesByCustomerId(id)
        .then((response) => {
          dispatch('setCustomerAdresses', response);
        })

    },

    /**============================================
     *?ANCHOR               CUSTOMER
     *=============================================**/
    async setCustomer({ commit }, newcustomer) {
      commit("SET_CUSTOMER", newcustomer);
    },

    getCustomer({ dispatch, state }, id) {
      state.CustomerLoading = true;
      clientAPI.methods.getCustomerById(id)
        .then((response) => {
          dispatch('setCustomer', response);
          dispatch('setCustomerContact', response.DefaultCustomerPerson);
        })
        .finally(() => state.CustomerLoading = false);

    },

    /**============================================
     *?ANCHOR               ADDRESS
     *=============================================**/
    setDeliveryAdress({ commit }, newcustomerdeliveryadress) {
      commit("SET_CUSTOMER_DELIVERY_ADRESS", newcustomerdeliveryadress);
    },

    async swapDeliveryAdress({ commit, state, rootGetters }, customerdeliveryadress) {
      //console.log("swapping delivery adress to ", customerdeliveryadress);
      commit("SET_SWAPPING_ADDRESS", true);
      try {
        const jobId = rootGetters['JobHub/JobParentjob/JobDetails'].Id;
        var idChanged = (state.CustomerDeliveryAdress?.Id != customerdeliveryadress?.Id)
        // use swap to update stamped address on job. 
        // do it silently if adress id was the same (address details changed but id is same)
        await clientAPI.methods.swapCustomerAdress(jobId, customerdeliveryadress.Id, !idChanged)
        commit("SET_CUSTOMER_DELIVERY_ADRESS", customerdeliveryadress);
      } finally {
        commit("SET_SWAPPING_ADDRESS", false);
      }
    },

    getCustomerDeliveryAdress({ dispatch }, ids) {
      clientAPI.methods.getCustomerAdressById(ids)
        .then((response) => {
          dispatch('setDeliveryAdress', response);
        })

    },

    /**============================================
     *?ANCHOR               CONTACT
     *=============================================**/
    setCustomerContact({ commit }, newcustomercontact) {
      commit("SET_CUSTOMER_CONTACT", newcustomercontact);
    },

    async swapCustomerContact({ commit, rootGetters }, newcustomercontact) {
      commit("SET_SWAPPING_CONTACT", true);
      try {
        const jobId = rootGetters['JobHub/JobParentjob/JobDetails'].Id;
        await clientAPI.methods.swapCustomerContact(jobId, newcustomercontact.Id)
        commit("SET_CUSTOMER_CONTACT", newcustomercontact);
      } finally {
        commit("SET_SWAPPING_CONTACT", false);
      }
    },

    getCustomerContact({ dispatch }, id) {
      clientAPI.methods.getCustomerContactById(id)
        .then((response) => {
          dispatch('setCustomerContact', response);
        })

    },
  },



  getters: {
    //lists
    CustomerAdresses: state => {
      return state.CustomerAdresses;
    },
    CustomerContacts: state => {
      return state.CustomerContacts;
    },

    //objects
    Customer: state => {
      return state.Customer;
    },
    CustomerLoading: state => {
      return state.CustomerLoading;
    },
    CustomerDeliveryAdress: (state, getters, rootState, rootGetters) => {
      return state.CustomerDeliveryAdress //if set use that
        ?? rootGetters['JobHub/JobSubjobs/MachineDeliveryAddressCandidate'] // else if machine has delivery address use that
        ?? getters.Customer?.DefaultDeliveryAddress; // else use customer default delivery address
    },
    CustomerContact: state => {
      return state.CustomerContact;
    },
    
    //loading states
    SwappingAddress: state => {
      return state.SwappingAddress;
    },
    SwappingContact: state => {
      return state.SwappingContact;
    },
  },

};
